<template>
  <v-layout data-qa="wrapperscreen-layout-dmdpy">
    <v-flex data-qa="wrapperscreen-flex-yndqrs">
      <v-row data-qa="wrapperscreen-row-yh4q2a">
        <v-col cols="12" lg="6" sm="6" md="6" xl="6" class="wrapper-padding" data-qa="wrapperscreen-col-8qse9m">
          <v-container fill-height fluid data-qa="wrapperscreen-container-80m55o">
            <v-row align="center" justify="center" data-qa="wrapperscreen-row-o7mz0o">
              <v-layout column wrap data-qa="wrapperscreen-layout-86y1gu">
                <v-flex xs12 sm12 md12 lg7 xl7 data-qa="wrapperscreen-flex-rwg91i">
                  <img data-qa="wrapperscreen-img-ubrhfw"
                    alt="logo"
                    height="80px"
                    width="140px"
                    :src="logo"
                    id="images"
                    class="loginTitle"
                  />
                </v-flex>
                <v-flex xs12 sm12 md12 lg7 xl7 data-qa="wrapperscreen-flex-92gozi">
                  <v-card flat data-qa="wrapperscreen-card-m7s8w">
                    <v-card-title class="pt-0" data-qa="wrapperscreen-card-title-0003cp">
                      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="wrapperscreen-flex-ivm22t">
                        <v-icon
                          @click="goBackToLoginScreen"
                          left
                          class="pb-1"
                           data-qa="wrapperscreen-icon-kwrra">mdi-close</v-icon
                        >
                        <span class="title font-weight-black" data-qa="wrapperscreen-span-mtc419">
                          {{ currentActionType }}
                        </span>
                      </v-flex>
                    </v-card-title>
                    <!-- <v-card-subtitle class="pl-14 pt-2" data-qa="wrapperscreen-card-subtitle-a0ip28">
                      {{ currentSubTitle }}
                    </v-card-subtitle> -->
                    <v-container fill-height fluid class="pt-0" data-qa="wrapperscreen-container-64x4im">
                      <v-card-text class="pt-0" data-qa="wrapperscreen-card-text-07pb2b">
                        <v-row align="start" justify="start" data-qa="wrapperscreen-row-a7sp24">
                          <div slot="content" data-qa="wrapperscreen-div-px1gz">
                            <PasswordChange v-if="resetPassword" />
                            <RetrieveLoginId
                              v-if="retrieveLoginId"
                              @loginActionEvent="handleLoginActions"
                            />
                            <!-- Activate User -->
                            <ActivateUser v-if="registerForOnlineBanking" />
                            <ChangeTemporaryPassword v-if="isChangeTemporaryPassword" :objData="{ loginID: userLoginID, subType: $route.params.changePasswordType }" />
                          </div>
                        </v-row>
                      </v-card-text>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="12" lg="6" sm="6" md="6" xl="6" class="pt-0" data-qa="wrapperscreen-col-zrigam">
          <v-flex data-qa="wrapperscreen-flex-qcv82"
            v-if="!showBgImage"
            :style="{ background: gradients }"
            id="gradient"
            class="box login__bgImages hidden-xs-only"
            xs12
            sm6
            md6
          />
          <v-flex data-qa="wrapperscreen-flex-l3c3n"
            v-if="showBgImage"
            :style="{ backgroundImage: 'url(' + image + ')' }"
            id="bgImg"
            class="box login__bgImages hidden-xs-only"
            xs12
            sm6
            md6
            lg6
            xl6
          />
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import '@/styles/pages/login/login.scss'
import customBgImage from '@/assets/login.jpg'
import preload from '@/util/preload'
import event from '@/util/event'
import ChangeTemporaryPassword from '@/components/DOB-Login/ChangeTempPassword.vue'
import '@/styles/pages/login/wrapper.scss'

export default {
  name: 'Register',
  components: {
    PasswordChange: () =>
      import('@/components/DOB-LoginScreen/ForgotPassword.vue'),
    RetrieveLoginId: () =>
      import('@/components/DOB-Login/RetrieveLoginId/RetrieveLoginId'),
    ActivateUser: () =>
      import('@/components/DOB-Login/RegisterForOnlineBanking/ActivateUser'),
    ChangeTemporaryPassword
  },
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      showBgImage: false,
      image: undefined,
      enableBgImage: undefined,
      configWithOtp: {
        config: this.config,
        resendOTPBtnDisabled: true,
        showNewPasswordSection: false,
        showPasswordResetSuccess: false,
        showOTPSection: false,
        resetPasswordOTPText: false,
        showUserIdAndPartyId: true,
        newPassword: null,
        renewPassword: null,
        resetPasswordOTP: null,
        resetPasswordTime: 10000,
        userId: null,
        partyId: null
      },
      userLoginID: '',
      resetPassword: false,
      retrieveLoginId: false,
      registerForOnlineBanking: false,
      isChangeTemporaryPassword: false,
      currentActionType: '',
      currentSubTitle: ''
    }
  },
  async created () {
    this.userLoginID = this.$route.params?.userLoginID
    this.clearStoredData()
    this.getAppDefaultConfig()
    await this.setNationalIdData()
    if (this.$route.params.actionType !== undefined) {
      this.screenActions(this.$route.params.actionType)
    } else {
      this.goBackToLoginScreen()
    }
    event.$on('goBackToLoginScreen', (arg) => {
      this.goBackToLoginScreen()
    })
  },
  methods: {
    async setNationalIdData () {
      // Get National ID Types
      const code = {
        codeReferences: [{ reference: 'PARTYIDTYPE' }]
      }
      const nationalIDType = JSON.parse(sessionStorage.getItem('PARTYIDTYPE'))
      if (typeof (nationalIDType) === 'object' && !nationalIDType) {
        await preload.getGenericCodes(code)
      }
    },
    getAppDefaultConfig () {
      this.enableBgImage = this.$appSettings.defaultConfigurations.enableCustomBackgroundImage
      const bgImage = this.enableBgImage ? this.$appSettings.serverSettings?.baseUrl + 'assets/custom/images/login.jpg' : customBgImage
      if (this.enableBgImage) {
        this.showBgImage = true
        this.image = bgImage
      } else {
        this.showBgImage = false
      }
    },
    clearStoredData () {
      const idTypes = sessionStorage.getItem('PARTYIDTYPE')
      sessionStorage.clear()
      sessionStorage.setItem('PARTYIDTYPE', idTypes)
      if ('isSmeLogin' in this.$route.params) sessionStorage.setItem('isSmeLogin', this.$route.params?.isSmeLogin)
      this.$store.dispatch('userStore/setUserData', { myAccounts: {}, loanAccounts: {}, mortgageAccounts: {}, tdProducts: {} })
      this.$store.dispatch('profileStore/removeProfileData')
    },
    goBackToLoginScreen () {
      this.$router.push('/login')
      // event.$emit('showLoginScreen', true)
    },
    screenActions (actionType) {
      this.currentActionType = actionType
      switch (actionType) {
        case 'resetPassword':
          this.currentActionType = this.$t('login.actionScreen.headings.forgotPasswordLabel')
          this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotPasswordLabel')
          this.resetPassword = true
          break
        case 'retrieveLoginId':
          this.currentActionType = this.$t('login.actionScreen.headings.forgotLoginIdLabel')
          this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotLoginIdLabel')
          this.retrieveLoginId = true
          break
        case 'registerForOnlineBanking':
          this.currentActionType = this.$t('login.actionScreen.headings.activateUserLabel')
          this.currentSubTitle = this.$t('login.actionScreen.subHeadings.activateUserLabel')
          this.registerForOnlineBanking = true
          break
        case 'changeTemporaryPassword':
          this.currentActionType = this.$t('login.actionScreen.headings.changeTemporaryPasswordLabel')
          this.currentSubTitle = this.$t('login.actionScreen.subHeadings.changeExpiredPasswordLabel')
          this.isChangeTemporaryPassword = true
          break
      }
    },
    handleLoginActions () {
      this.resetPassword = false
      this.retrieveLoginId = false
      this.registerForOnlineBanking = false
      this.isChangeTemporaryPassword = false
    }
  }
}
</script>
